export const iconFontAwesomeSocialImages = (
	<i className="fa-solid fa-images"></i>
);
